import { render, staticRenderFns } from "./FlowDocumentView.vue?vue&type=template&id=1e079120&scoped=true&"
import script from "./FlowDocumentView.vue?vue&type=script&lang=ts&"
export * from "./FlowDocumentView.vue?vue&type=script&lang=ts&"
import style0 from "./FlowDocumentView.vue?vue&type=style&index=0&id=1e079120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e079120",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VExpandTransition,VFileInput,VIcon,VRow,VTooltip})
